// DEPENDENCIES
import React from "react";
import { Link as RouterLink } from "react-router-dom";

// CONTEXT
import {
	unsavedChangesGuardRef,
	defaultUnsavedChangesMessage,
} from "../../../context/unsavedChangesGuard";

// Drop-in replacement for react-router-dom's Link, used everywhere
// Navigation.js currently passes `component={RouterLink}` to a MUI
// component. Before following the link, it checks whether the currently
// mounted page registered an unsaved-changes guard (see
// unsavedChangesGuard.js) and, if so, confirms with the user first.
const GuardedRouterLink = React.forwardRef(({ onClick, ...props }, ref) => {
	const handleClick = (event) => {
		if (unsavedChangesGuardRef.current?.()) {
			const confirmed = window.confirm(defaultUnsavedChangesMessage);
			if (!confirmed) {
				event.preventDefault();
				return;
			}
		}
		onClick?.(event);
	};

	return <RouterLink ref={ref} onClick={handleClick} {...props} />;
});

export default GuardedRouterLink;
